<template>
  <div class="buying">
    <div class="buying-nav">
      <div class="nav-items">
        <div class="el-tabs__active-bar" id="bar" ref="headerBar"></div>
        <div class="buying-items">
          <div :class="is_active==item.ref?'is-active':''" :key="index" :ref="item.ref" @click="setBarWidth(item)" class="buying-for" v-for="(item, index) in nvaBar">
            <div class="buying-item">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <singleVue v-show="is_active === 'single'"></singleVue>
    <multipleVue v-show="is_active === 'multiple'"></multipleVue>
    <!-- <sublibraryVue v-show="is_active === 'sublibrary'"></sublibraryVue> -->
  </div>
</template>

<script>
  import singleVue from '@/components/buying/single.vue';
  import multipleVue from '@/components/buying/multiple.vue';
  import sublibraryVue from '@/components/buying/sublibrary.vue';

  export default {
    name: 'BuyIndex',
    components: {
      singleVue, multipleVue, sublibraryVue
    },
    data() {
      return {
        nvaBar: [
          {
            title: '购买单个资源',
            api: '/portal/sybpay/purchaseBooks',
            ref: 'single'
          },
          {
            title: '购买多个资源',
            api: '/portal/sybpay/purchaseBooks',
            ref: 'multiple'
          },
          // 暂时不启用
          // {
          //     title: '购买子库资源',
          //     api:'/portal/sybpay/purchaseSublibrary',
          //     ref:'sublibrary'
          // },
          // 暂时不启用
          // {
          //     title: '购买全站资源',
          //     api:'',
          //     ref:'totalStation'
          // }
        ],
        is_active: 'sublibrary',
      };
    },

    mounted() {
      this.setBarWidth({
        title: '购买单个资源',
        api: '/portal/sybpay/purchaseBooks',
        ref: 'single'
      })
    },

    methods: {
      // 选择页面
      setBarWidth(item) {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let ref = item.ref
        var t = this.$refs[ref][0]
        this.is_active = item.ref
        var tem = t.offsetLeft / fontSize
        var widht = t.clientWidth
        var intewidht = parseInt(widht) / fontSize
        var w = this.$refs.headerBar
        w.setAttribute('style', ' transform: translateX(' + tem + 'rem);width:' + intewidht + 'rem;');
      },
      // 页面跳转 重新请求
      pageChange() {
      },
    },
  };
</script>

<style lang="less" scoped>
  .buying {
    width: 62.5rem;
    min-width: 62.5rem;
    margin: 1.563rem auto;
    min-height: 24.635rem;

    .buying-nav {
      background-color: #fff;
      padding: 0 1.563rem;

      .nav-items {
        position: relative;

        .el-tabs__active-bar {
          height: 0.104rem;
          background-color: #b1222b;
        }

        .buying-items {
          display: flex;
          justify-content: space-around;
          border-bottom: 0.052rem solid #dedede;
          height: 5.208rem;
          line-height: 5.208rem;

          .buying-for {
            cursor: pointer;
            color: #333333;

            .buying-item {
              font-size: 1.146rem;
              letter-spacing: 0.021rem;
            }
          }

          .buying-for.is-active {
            color: #b1222b;
          }
        }
      }

    }
  }
</style>
